/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
window.abideDatePresentIfExpiresAtDateValidator = function($el, _req, _parent) {
  const value = ($('#passtype_pass_length').val() !== "Expires on a specific date") ||
    (($('#passtype_pass_length').val() === "Expires on a specific date") &&
      ($el.val() !== ''));
  return value;
};

window.abideDatePresentIfStartDateValidator = function($el, _req, _parent) {
  const value = ($('#passtype_start_date_selection').val() !== "true") ||
    (($('#passtype_start_date_selection').val() === "true") &&
      ($el.val() !== ''));
  return value;
};

window.abideGreaterThanZeroValidator = function($el, required, _parent) {
  if (!required) {
    return true;
  }
  return Number.parseFloat($el.val().split(',').join('')) > 0.0;
};

window.abideLimitSelectedIfLimitedClass = function($el, _req, _parent) {
  const value = !$('#course_limit_attendees').is(':checked') ||
    ($('#course_limit_attendees').is(':checked') &&
      ($el.val() !== ''));
  return value;
};

window.abideInstructorSelectedIfLimitedView = function($el, _req, _parent) {
  const value = !$('#company_access_instructor_limit_view').is(':checked') ||
    ($('#company_access_instructor_limit_view').is(':checked') && ($el.val() !== ''));
  return value;
};

window.abideNumberOfPunchesSelectedIfUnlimitedPasstype = ($el, _req, _parent) => !$('#passtype_pass_type_punch_card').is(':checked') ||
  ($('#passtype_pass_type_punch_card').is(':checked') &&
    ($el.val() !== ''));

window.abidePassPresentIfLinkedToPass = function($el, _req, _parent) {
  const value = !$('#series_assign_specific_pass').is(':checked') ||
    ($('#series_assign_specific_pass').is(':checked') &&
      ($el.val() !== ''));
  return value;
};

window.abidePassPresentIfPrivateForAttendance = function($el, _req, _parent) {
  const value = !$('#private_sessions_create_form_commitment_type_attendance').is(':checked') ||
    ($('#private_sessions_create_form_commitment_type_attendance').is(':checked') &&
      ($el.val() !== ''));
  return value;
};

window.abideRoundNumber = function($el, _req, _parent) {
  if ($el.is(":hidden")) {
    return true;
  }
  const value = parseFloat($el.val());
  return !Number.isNaN(value) && ((value % 1) === 0) && (value > 0);
};

window.abideSelectedValue = function($el, _req, _parent) {
  const value = ($el.val() !== '') && ($el.val() !== null);
  return value;
};

window.abideSelectedValueUnlessOnlinePayment = function($el, _req, _parent) {
  const value = $('#card-element').is(':visible') ||
    (($el.val() !== '') && ($el.val() !== null));
  return value;
};

window.abideSelectedValueUnlessOnlinePaymentOrPaymentReceived = function($el, _req, _parent) {
  const value = $('#card-element').is(':visible') ||
    (!$('#pass_payment_received').is(':checked')) ||
    ($('#pass_payment_received').is(':checked') && ($el.val() !== '') && ($el.val() !== null));
  return value;
};

window.abideSetIfNotAllCustomers = function($el, _req, _parent) {
  const value = ($el.val() !== '') && ($el.val() !== null);
  return (!value && $('#message_all_customers').is(':checked')) || value;
};

window.abideAtLeastOneCollection = function($el, _req, _parent) {
  const value = ($el.closest('.field.check_boxes').find('input[type=checkbox]:checked').length > 0) ||
    (($('#resource_new_collection').val() !== '') && ($('#resource_new_collection').val() !== null));
  return value;
};

window.abideResourceProviderSelectedIfVideo = ($el, _req, _parent) => !$('#resource_content_type_video').is(':checked') ||
  ($('#resource_content_type_video').is(':checked') &&
    ($el.closest('.field.radio_buttons').find('input[type=radio]:checked').length > 0));
